var render, staticRenderFns
import script from "./yssl.vue?vue&type=script&lang=js"
export * from "./yssl.vue?vue&type=script&lang=js"
import style0 from "./yssl.vue?vue&type=style&index=0&id=54c2e142&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports